import { ArrowRightOutlined } from '@ant-design/icons';
import { Draft } from '@resi-media/resi-ui';
import { usePrefix } from '@studio/hooks/use-prefix';

type Props = {
  onClick: () => void;
  showEndNode?: boolean;
  showJoinEarly: boolean;
  sizeVariant?: Draft.ButtonBase.Size;
};

const LiveJoinNowButton = ({ onClick, showEndNode = true, showJoinEarly, sizeVariant = 'm' }: Props) => {
  const { prefixNS } = usePrefix('components:', 'liveJoinNowButton');

  return (
    <Draft.Button
      colorVariant={showJoinEarly ? 'neutral' : 'accent'}
      dataTestId="live-video-join-now-button"
      {...(showEndNode && { endNode: <ArrowRightOutlined /> })}
      label={prefixNS(showJoinEarly ? 'preLiveLabel' : 'liveLabel')}
      onClick={onClick}
      sizeVariant={sizeVariant}
    />
  );
};

LiveJoinNowButton.displayName = 'LiveJoinNowButton';

export { LiveJoinNowButton };
